/**
 * Consecutive failed WebSocket connects before one is logged as an error. graphql-ws
 * retries forever with a doubling wait (1 s, 2 s, 4 s, 8 s ...), so five failures in a
 * row mean the server has been unreachable for at least 15 seconds. A single failure is
 * the normal first reconnect after a laptop wakes or the network changes.
 */
export const WS_CONNECT_FAILURES_BEFORE_ERROR = 5;

/** Counts failed WebSocket connects since the last successful one. */
export function createWsConnectFailureCounter() {
  let failures = 0;
  return {
    connected() {
      failures = 0;
    },
    /** Records a failed connect; true for the one failure that should be logged as an error. */
    failed(): boolean {
      failures += 1;
      return failures === WS_CONNECT_FAILURES_BEFORE_ERROR;
    },
  };
}
